import { type NavItemDraw } from "./protocols";

export const usePrivateNavItems = (): Ref<NavItemDraw[]> => {
  const { $tt } = useNuxtApp();

  return computed(() => {
    return [
      {
        label: $tt("private.nav.start"),
        to: "/painel",
        code: "root",
        icon: "tdesign:home",
      },
      {
        label: $tt("private.nav.wallet"),
        to: "/painel/wallet",
        code: "wallet",
        img: "/short-logo-hurst-white.svg",
        imgActive: "/short-logo-hurst.svg",
      },
      {
        label: $tt("private.nav.pending"),
        to: "/painel/pendentes",
        code: "pending",
        icon: "ph:target-bold",
      },
      {
        label: $tt("private.nav.publicOffers"),
        to: "/painel/ofertas-publicas",
        code: "public-offers",
        icon: "f7:money-dollar-circle",
      },
      {
        label: $tt("private.nav.opportunities"),
        to: "/painel/oportunidades",
        code: "opportunities",
        icon: "f7:money-dollar-circle-fill",
      },
      {
        label: $tt("private.nav.closedInvestments"),
        to: "/painel/encerrados",
        code: "closed",
        icon: "fluent:checkmark-lock-24-filled",
      },
      {
        label: $tt("private.nav.indications"),
        to: "/painel/indicacoes",
        code: "indications",
        icon: "mdi:gift-outline",
      },
      {
        label: $tt("private.nav.help"),
        to: "/painel/ajuda",
        code: "help",
        icon: "bx:user",
      },
    ];
  });
};
